import React from "react";
import Checkbox from "../common/Checkbox";
import Input from "../common/Input";
import Select from "../common/Select";
import CountyList from "../../options/counties.json";

function IndianaReferral({ data, handleChange, handleSave }) {
  return (
    <>
      <div>
        <div className="row mb-4">
          <div className="col">
            <Input
              name="referralDateTime"
              label="Referral Date and Time"
              type="datetime-local"
              onChange={handleChange}
              value={data.DynamicFields.results.referralDateTime}
            />
          </div>
          <div className="col">
            <Input
              name="timeResponded"
              label="Time Responded"
              type="datetime-local"
              onChange={handleChange}
              value={data.DynamicFields.results.timeResponded}
            />
          </div>
          <div className="col">
            <Select
              name="referringCountyName"
              label="Referring County"
              onChange={handleChange}
              value={data.DynamicFields.results.referringCountyName}
              options={CountyList.filter(
                (county) => county.state_name === "Indiana"
              )}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Input
              name="fcmSupervisorName"
              label="FCM Supervisor Name"
              onChange={handleChange}
              value={data.DynamicFields.results.fcmSupervisorName}
            />
          </div>
          <div className="col">
            <Input
              name="fcmSupervisorPhone"
              label="FCM Supervisor Phone"
              onChange={handleChange}
              value={data.DynamicFields.results.fcmSupervisorPhone}
            />
          </div>
          <div className="col">
            <Input
              name="fcmSupervisorEmail"
              label="FCM Supervisor Email"
              onChange={handleChange}
              value={data.DynamicFields.results.fcmSupervisorEmail}
            />
          </div>
        </div>
        <div className="mb-4 ms-4">
          <Checkbox
            name="statewide"
            label="Statewide"
            onChange={handleChange}
            checked={data.DynamicFields.results.statewide === "true"}
          />
        </div>
        <div className="row">
          <div className="col-8">
            <Select
              name="placementTypeOS"
              label="PlacementType"
              onChange={handleChange}
              value={data.DynamicFields.results.placementTypeOS}
              options={[
                { name: "Initial Removal", _id: "InitialRemoval" },
                { name: "Respite Only", _id: "RespiteOnly" },
                { name: "Residential Step-Down", _id: "ResidentialStepDown" },
                {
                  name: "Residential Disruption",
                  _id: "ResidentialDisruption",
                },
                { name: "ESC Step Down", _id: "ESCStepDown" },
                { name: "LCPA Disruption", _id: "LCPADisruption" },
                { name: "DCS Disruption", _id: "DCSDisruption" },
                {
                  name: "Relative/Kinship Disruption",
                  _id: "Relative/KinshipDisruption",
                },
                {
                  name: "Juvenile Detention Release",
                  _id: "JuvenileDetentionRelease",
                },
                {
                  name: "Trial Home Visit Disruption",
                  _id: "TrialHomeVisitDisruption",
                },
                { name: "Group Home Step Down", _id: "GroupHomeStepDown" },
                { name: "Runaway", _id: "Runaway" },
                { name: "Accute Stay/30 Day D&E Discharge", _id: "AccuteStay" },
                {
                  name: "In Home Chins Disruption",
                  _id: "InHomeChinsDisruption",
                },
                { name: "Hospital Release", _id: "HospitalRelease" },
                { name: "Other", _id: "PlacementOther" },
              ]}
            />
          </div>
          <div className="col-4">
            {data.DynamicFields.results.placementTypeOS ===
              "PlacementOther" && (
              <Input
                name="placementOther"
                label="Other"
                onChange={handleChange}
                checked={data.DynamicFields.results.placementOther === "true"}
              />
            )}
          </div>
        </div>
        {/* <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="initialRemoval"
                label="Initial Removal"
                onChange={handleChange}
                checked={data.DynamicFields.results.initialRemoval === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="respiteOnly"
                label="Respite Only"
                onChange={handleChange}
                checked={data.DynamicFields.results.respiteOnly === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="residentialStepDown"
                label="Residential Step-Down"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.residentialStepDown === "true"
                }
              />
            </div>
            <div className="col">
              <Checkbox
                name="residentialDisruption"
                label="Residential Disruption"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.residentialDisruption === "true"
                }
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="escStepDown"
                label="ESC Step Down"
                onChange={handleChange}
                checked={data.DynamicFields.results.escStepDown === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="lcpaDisruption"
                label="LCPA Disruption"
                onChange={handleChange}
                checked={data.DynamicFields.results.lcpaDisruption === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="dcsDisruption"
                label="DCS Disruption"
                onChange={handleChange}
                checked={data.DynamicFields.results.dcsDisruption === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="relativeDisruption"
                label="Relative/Kinship Disruption"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.relativeDisruption === "true"
                }
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="juvenileDetentionRelease"
                label="Juvenile Detention Release"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.juvenileDetentionRelease === "true"
                }
              />
            </div>
            <div className="col">
              <Checkbox
                name="trialDisruption"
                label="Trial Home Visit Disruption"
                onChange={handleChange}
                checked={data.DynamicFields.results.trialDisruption === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="groupStepDown"
                label="Group Home Step Down"
                onChange={handleChange}
                checked={data.DynamicFields.results.groupStepDown === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="runaway"
                label="Runaway"
                onChange={handleChange}
                checked={data.DynamicFields.results.runaway === "true"}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Checkbox
                name="accuteStay"
                label="Accute Stay/30 Day D&E Discharge"
                onChange={handleChange}
                checked={data.DynamicFields.results.accuteStay === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="chinsDisruption"
                label="In Home Chins Disruption"
                onChange={handleChange}
                checked={data.DynamicFields.results.chinsDisruption === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="hospitalRelease"
                label="Hospital Release"
                onChange={handleChange}
                checked={data.DynamicFields.results.hospitalRelease === "true"}
              />
            </div>
            <div className="col">
              <Input
                name="placementOther"
                label="Other"
                onChange={handleChange}
                checked={data.DynamicFields.results.placementOther === "true"}
              />
            </div>
          </div>*/}
        <div className="row mb-4">
          <div className="col-4">
            <Select
              name="levelOfCare"
              label="Level of Care"
              onChange={handleChange}
              value={data.DynamicFields.results.levelOfCare}
              options={[
                { name: "1", _id: "1" },
                { name: "2", _id: "2" },
                { name: "3", _id: "3" },
                { name: "4", _id: "4" },
                { name: "5", _id: "5" },
                { name: "6", _id: "6" },
                { name: "7", _id: "7" },
                { name: "Unknown", _id: "Unknown" },
              ]}
            />
          </div>
          <div className="col-4">
            <Select
              name="permanencyPlan"
              label="Permanency Plan"
              onChange={handleChange}
              value={data.DynamicFields.results.permanencyPlan}
              options={[
                {
                  name: "BBDS (Bureau of Developmental Disability Service ",
                  _id: "BDDS",
                },
                { name: "Reunification", _id: "Reunification" },
                {
                  name: "Reunification w/Concurrent Plan of Adoption",
                  _id: "ReunificationAdoption",
                },
                { name: "Adoption", _id: "Adoption" },
                {
                  name: "APPLA-Another Planned Permanent Living Arrangement",
                  _id: "APPLA",
                },
                { name: "Guardianship", _id: "Guardianship" },
              ]}
            />
          </div>
        </div>
        <div className="row mb-4 ps-4">
          <div className="col">
            <Checkbox
              name="siblingGroup"
              label="Sibling Group"
              onChange={handleChange}
              checked={data.DynamicFields.results.siblingGroup === "true"}
            />
          </div>
          <div className="col">
            <Checkbox
              name="spanishSpeaking"
              label="Spanish Speaking"
              onChange={handleChange}
              checked={data.DynamicFields.results.spanishSpeaking === "true"}
            />
          </div>
          <div className="col">
            <Checkbox
              name="teenMomBaby"
              label="Teen Mom/Baby"
              onChange={handleChange}
              checked={data.DynamicFields.results.teenMomBaby === "true"}
            />
          </div>
          <div className="col">
            <Checkbox
              name="previouslyAdopted"
              label="Previously Adopted"
              onChange={handleChange}
              checked={data.DynamicFields.results.previouslyAdopted === "true"}
            />
          </div>
        </div>
        {data.DynamicFields.results.siblingGroup === "true" ? (
          <div className="row">
            <div className="col-4">
              <Input
                name="numberOfSiblings"
                label="Number of Siblings"
                onChange={handleChange}
                value={data.DynamicFields.results.numberOfSiblings}
              />
            </div>
            <div className="col-8">
              <Input
                name="siblingInfo"
                label="Names and Dates of Birth"
                onChange={handleChange}
                value={data.DynamicFields.results.siblingInfo}
              />
            </div>
          </div>
        ) : null}
        <div className="mb-2 h5">History</div>
        <div className="border border-dark rounded p-4 mb-4 bg-white">
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="abandonment"
                label="Abandonment"
                onChange={handleChange}
                checked={data.DynamicFields.results.abandonment === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="deathOfParent"
                label="Death Of Parent"
                onChange={handleChange}
                checked={data.DynamicFields.results.deathOfParent === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="parentalIncarceration"
                label="Parental Incarceration"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.parentalIncarceration === "true"
                }
              />
            </div>
            <div className="col">
              <Checkbox
                name="domesticViolence"
                label="Domestic Violence"
                onChange={handleChange}
                checked={data.DynamicFields.results.domesticViolence === "true"}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="deathOfSibling"
                label="Fatality/Death of Sibling"
                onChange={handleChange}
                checked={data.DynamicFields.results.deathOfSibling === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="homelessness"
                label="Homelessness"
                onChange={handleChange}
                checked={data.DynamicFields.results.homelessness === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="parentalSubstanceUse"
                label="Parental Substance Use"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.parentalSubstanceUse === "true"
                }
              />
            </div>
            <div className="col">
              <Checkbox
                name="parentalMentalHealth"
                label="Parental Mental Health"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.parentalMentalHealth === "true"
                }
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="fySexualPred"
                label="FY Alleged Sexual Predator"
                onChange={handleChange}
                checked={data.DynamicFields.results.fySexualPred === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="fyMentalHealth"
                label="FY Mental Health"
                onChange={handleChange}
                checked={data.DynamicFields.results.fyMentalHealth === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="fySubstanceUse"
                label="FY Substance Use"
                onChange={handleChange}
                checked={data.DynamicFields.results.fySubstanceUse === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="noHistory"
                label="No History"
                onChange={handleChange}
                checked={data.DynamicFields.results.noHistory === "true"}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="physicalAbuse"
                label="Physical Abuse"
                onChange={handleChange}
                checked={data.DynamicFields.results.physicalAbuse === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="emotionalAbuse"
                label="Emotional Abuse"
                onChange={handleChange}
                checked={data.DynamicFields.results.emotionalAbuse === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="neglect"
                label="Neglect"
                onChange={handleChange}
                checked={data.DynamicFields.results.neglect === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="educationalNeglect"
                label="Educational Neglect"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.educationalNeglect === "true"
                }
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col">
              <Checkbox
                name="medicalNeglect"
                label="Medical Neglect"
                onChange={handleChange}
                checked={data.DynamicFields.results.medicalNeglect === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="sexualAbuse"
                label="Sexual Abuse"
                onChange={handleChange}
                checked={data.DynamicFields.results.sexualAbuse === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="sexTraffickingVictim"
                label="Sex Trafficking Victim"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.sexTraffickingVictim === "true"
                }
              />
            </div>
            <div className="col">
              <Checkbox
                name="lackOfSupervision"
                label="Lack of Supervision"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.lackOfSupervision === "true"
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Checkbox
                name="unsafeHome"
                label="Unsafe Home"
                onChange={handleChange}
                checked={data.DynamicFields.results.unsafeHome === "true"}
              />
            </div>
            <div className="col">
              <Checkbox
                name="juvenileDelinquent"
                label="Juvenile Delinquent"
                onChange={handleChange}
                checked={
                  data.DynamicFields.results.juvenileDelinquent === "true"
                }
              />
            </div>
            <div className="col">
              <Input
                name="historyOther"
                label="Other"
                onChange={handleChange}
                checked={data.DynamicFields.results.hitoryOther === "true"}
              />
            </div>
            <div className="col"></div>
          </div>
        </div>
        <Input
          name="reasonForChange"
          label="Reason For Placement Change"
          onChange={handleChange}
          value={data.DynamicFields.results.reasonForChange}
          rows="2"
        />
        <Input
          name="desiredSetting"
          label="Desired Placement Setting"
          onChange={handleChange}
          value={data.DynamicFields.results.desiredSetting}
          rows="2"
        />
        <Input
          name="strengths"
          label="Strengths"
          onChange={handleChange}
          value={data.DynamicFields.results.strengths}
          rows="2"
        />
        <Input
          name="medicalMentalHealthInfo"
          label="Medical and Mental Health Info"
          onChange={handleChange}
          value={data.DynamicFields.results.medicalMentalHealthInfo}
          rows="2"
        />
        <Input
          name="educationalInformation"
          label="Educational Information"
          onChange={handleChange}
          value={data.DynamicFields.results.educationalInformation}
          rows="2"
        />
        <Input
          name="meetingNeeds"
          label="Meeting the Needs of this Child"
          onChange={handleChange}
          value={data.DynamicFields.results.meetingNeeds}
          rows="2"
        />
        <Input
          name="visitationPlan"
          label="Visitation Plan"
          onChange={handleChange}
          value={data.DynamicFields.results.visitationPlan}
          rows="2"
        />
        <Input
          name="comments"
          label="Comments"
          onChange={handleChange}
          value={data.DynamicFields.results.comments}
          rows="2"
        />
        {/* <Select
          name="secondaryDeferralReason"
          label="Secondary Deferral Reason"
          onChange={handleChange}
          value={data.DynamicFields.results.secondaryDeferralReason}
          options={[
            { name: "Age", _id: "Age" },
            { name: "Aggression", _id: "Aggression" },
            { name: "Alcohol/Substance Use", _id: "AlcoholSubstance" },
            {
              name: "Child Needs Home with Single Parent",
              _id: "SingleParent",
            },
            { name: "Child Needs Private Bedroom", _id: "PrivateBedroom" },
            { name: "Criminal Activity", _id: "CriminalActivity" },
            { name: "Delayed Response Time", _id: "DelayedResponse" },
            { name: "Self Harm Behaviors", _id: "SelfHarm" },
            { name: "Gender", _id: "Gender" },
            { name: "Geography", _id: "Geography" },
            {
              name: "Home with No Younger Children Needed",
              _id: "NoYoungerChildren",
            },
            { name: "Medical Needs", _id: "MedicalNeeds" },
            { name: "Mental Health", _id: "MentalHealth" },
            { name: "Persistent AWOL", _id: "AWOL" },
            { name: "Placement No Longer Needed", _id: "NotNeeded" },
            { name: "Poor Match with Current Youth", _id: "PoorMatch" },
            { name: "Sexualized Behavior", _id: "SexualizedBehavior" },
            { name: "Sibling Set", _id: "SiblingSet" },
            { name: "Stay at Home Parent Needed", _id: "StayAtHomeParent" },
            { name: "Suicidal Ideation", _id: "Suicidal" },
            {
              name: "Transportation/Visitation Needs",
              _id: "TransportationNeeded",
            },
            { name: "Two Parent Home Needed", _id: "TwoParents" },
            { name: "Pregnant or Parenting Teen", _id: "PregnantParenting" },
            {
              name: "Supervision Requirements of Youth",
              _id: "Supervision Requirements",
            },
            { name: "Child Care Issue", _id: "ChildCare" },
            {
              name: "Home with No Other Children Needed",
              _id: "NoOtherChildren",
            },
          ]}
        /> */}
        <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
          Save Referral
        </button>
      </div>
    </>
  );
}

export default IndianaReferral;
